import { generate_random_color } from "#shared/utility_functions/color_functions";
import { blockerFunction } from "@src/utility_functions/utility_functions/dom_functions";
import { validateFileInterval } from "@src/utility_functions/inputValidation/validateFileInterval";

export const parseJSONDataIntoIntervals = async (
  data,
  setParsedItemCount,
  setFileError,
) => {
  let returnValue = {
    errors: 0,
    intervals: [],
  };
  for (let index = 0; index < data.length; index++) {
    setParsedItemCount((prev) => {
      return prev + 1;
    });

    const item = data[index];
    let startTime = findStartTime(item);
    let endTime = findEndTime(item);
    //measure if the starttime is before the endtime, if not, swap them
    if (startTime && endTime && new Date(startTime) > new Date(endTime)) {
      const temp = startTime;
      startTime = endTime;
      endTime = temp;
    }
    //if startTime is missing, skip this item and add to error count
    if (!startTime) {
      returnValue.errors += 1;
      continue;
    }
    const newInterval = {
      label: findLabel(item),
      description: findDescription(item),
      emoji: item.emoji || "",
      startTime: startTime,
      endTime: endTime,
      primaryColor: item.primaryColor || generate_random_color("color"),
      secondaryColor: item.secondaryColor || generate_random_color("shade"),
    };
    const intervalValid = validateFileInterval(
      newInterval,
      setFileError,
      index,
    );
    await blockerFunction(10);
    if (intervalValid) {
      returnValue.intervals.push(newInterval);
    } else {
      returnValue.errors += 1;
    }
  }
  return returnValue;
};

const formatStartTime = (startTime) => {
  const d = new Date(startTime);
  d.setHours(0, 0, 0, 0);
  return d.toISOString().slice(0, 16);
};

const findStartTime = (item) => {
  const matchingKeys = [
    "start",
    "startTime",
    "startDate",
    "begin",
    "from",
    "start_time",
    "start_date",
    //"birth",
    "reign_start",
  ];
  for (const key of matchingKeys) {
    let startTimeFormatted;
    if (item[key]) {
      try {
        startTimeFormatted = formatStartTime(item[key]);
      } catch (error) {
        //if the date is invalid, log the error and return null
        console.error(
          `Invalid date format for key "${key}":`,
          item[key],
          "Error:",
          error,
        );
        return false;
      }
      return startTimeFormatted;
    }
  }
  return null;
};

const findEndTime = (item) => {
  const matchingKeys = [
    "end",
    "endTime",
    "endDate",
    "to",
    "until",
    "end_time",
    "end_date",
    //"death",
    "reign_end",
  ];
  for (const key of matchingKeys) {
    if (item[key]) {
      return item[key];
    }
  }
  return null;
};

const findLabel = (item) => {
  const matchingKeys = ["label", "name", "title"];
  for (const key of matchingKeys) {
    if (item[key]) {
      return item[key];
    }
  }
  return null;
};

const findDescription = (item) => {
  const matchingKeys = ["description", "desc", "details", "info", "notes"];
  for (const key of matchingKeys) {
    if (item[key]) {
      return item[key];
    }
  }
  return null;
};
